import { useForm } from 'react-hook-form';

import { Typography, Box } from '@mui/material';
import MuiDialog from 'components/MuiDialog';

import { SurveyDialogProps, TTransfusionAgreeDefaultValues } from '../../type';

import CommonPatientInfo from '../../components/CommonPatientInfo';
import FirstContents from './FirstContents';
import TwiceContents from './TwiceContents';

const AdmissionGuide = (
  props: SurveyDialogProps<TTransfusionAgreeDefaultValues>
) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { handleSubmit } = useForm({
    defaultValues,
  });

  const onSubmit = () => {};

  return (
    <MuiDialog.SurveyFormPrint
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Typography
        sx={{
          margin: '40px auto 40px auto',
          fontWeight: '700',
          fontSize: '16px',
          textAlign: 'center',
        }}
      >
        Hướng dẫn nhập viện cho bệnh nhân
      </Typography>
      <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
      <Box sx={{ marginTop: '48px' }}>
        <FirstContents />
        <TwiceContents />
      </Box>
    </MuiDialog.SurveyFormPrint>
  );
};

export default AdmissionGuide;
